export default __webpack_public_path__ + "img/d660571fa8fb233128f9d631ac2c35f5.png";